import styled from 'styled-components'
import { red, grayLight, grayDarker } from '@bufferapp/ui/style/colors'

import { flexRow, flexCol } from '~/shared/styles/layout'
import { baseFont } from '~/shared/styles/font'

/**
 *
 */
export const Wrapper = styled.div`
  border: 1px solid ${grayLight};
  border-radius: 4px;
  margin-right: 8px;
  width: 200px;
  height: 50px;

  & > div > div > ul {
    max-height: 216px;
  }
`

export const ButtonWrapper = styled.div`
  ${flexRow}
  justify-content: space-between;
  cursor: pointer;
  color: ${grayDarker};
  height: 100%;
  padding: 0px 8px;
`

export const ChannelWrapper = styled.div`
  ${flexRow}
  cursor: pointer;
  margin: 8px 0px;
  width: 200px;
`

export const AvatarWrapper = styled.div`
  margin-right: 8px;
`

export const ChannelInfo = styled.div`
  ${flexCol}
  align-items: flex-start;
  flex: 1;
`

export const ChannelName = styled.p`
  ${baseFont}
  font-weight: 500;
  color: ${grayDarker};
`

export const ChannelStatus = styled.p`
  ${baseFont}
  font-weight: 500;
  color: ${red};
`
